import qrcode from 'qrcode-generator';

// A crisp, scalable QR code drawn as one SVG path (dark modules on a white quiet zone, which every scanner reads).
const QrCode = ({ value, size = 240, label }: { value: string; size?: number; label?: string }) => {
  const qr = qrcode(0, 'M');
  qr.addData(value);
  qr.make();
  const count = qr.getModuleCount();
  const quiet = 2;
  let path = '';
  for (let row = 0; row < count; row++) for (let col = 0; col < count; col++) if (qr.isDark(row, col)) path += `M${col + quiet} ${row + quiet}h1v1h-1z`;
  const total = count + quiet * 2;
  return <svg width={size} height={size} viewBox={`0 0 ${total} ${total}`} role="img" aria-label={label || 'QR code'} shapeRendering="crispEdges">
    <rect width={total} height={total} rx={1.2} fill="#fff" />
    <path d={path} fill="#0b0911" />
  </svg>;
};

export default QrCode;
